const TransactionStepEnum = {
  CALCULATOR: 'CALCULATOR',
  BENEFICIARY: 'BENEFICIARY',
  PAYMENT: 'PAYMENT',
  SUMMARY: 'SUMMARY', // It should same with RPI steps enum as payment card component using for both transaction and rpi
  SOURCE_OF_FUND: 'SOURCE_OF_FUND'
}

export default TransactionStepEnum
